import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const ProfileInfoStyled = styled.div`

  #firstSectionStyle, #boxOtherInfoBox, #boxObsevationsContainer, .documentsInfoBody {
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;
  }

  /* Contenido de las tabs inferiores en la misma tarjeta blanca que las notas, con la tabla dentro */
  #observations-wrapper, #push-offers-wrapper, #last-citations-wrapper {
    margin-top: 0 !important;
    padding: 24px !important;
    background: ${tokens.color.background.default};
    box-shadow: 0 4px 6px rgba(98, 102, 113, 0.06), 0 2px 2px rgba(98, 102, 113, 0.06);
    border-radius: 6px;

    .observations-table {
      padding: 0 !important;
    }
  }

  /* Sin el margen negativo del Grid, para que la tarjeta mida lo mismo que la de las notas */
  .MuiGrid-container:has(> #observations-wrapper),
  .MuiGrid-container:has(> #push-offers-wrapper),
  .MuiGrid-container:has(> #last-citations-wrapper) {
    margin: 0 !important;
    width: 100% !important;
  }

  #ProfileActionsButtons {
    justify-content: flex-end;
    align-items: center;
  }

  /* Menos aire entre el paginador (flechas y contador) y las tabs de ofertas */
  .tabpanel_box {
    margin: 4px 0 0 -16px;
    border-bottom: 0 !important;
  }

  /* La tab de la oferta queda pegada al bloque blanco: el contenedor de MUI mide 48 px y la
     tab 40 px, así que se iguala para que no quede hueco debajo; el bloque no lleva margen arriba */
  .candidature_tabs_container,
  .candidature_tabs_container .MuiTabs-scroller,
  .candidature_tabs_container .MuiTabs-flexContainer {
    min-height: 40px;
    height: 40px;
  }

  .candidature_tabs_container .candidatureTabs {
    margin-bottom: 0;
  }

  #firstSectionStyle {
    margin-top: 0 !important;
  }

  /* Tabs inferiores: el contenedor a la altura de la tab */
  .MuiTabs-root:not(.candidature_tabs_container) {
    min-height: 40px;
  }

  /* Tabs inferiores (notas, histórico, push, citaciones): 14 px, 600 la activa y 400 el resto,
     con el indicador en el color del cliente */
  .documentsInfoTitle.tab-item {
    min-height: 40px;
    padding: 8px 16px;
    font-size: 14px;
    line-height: 20px;
  }

  .MuiTabs-root:not(.candidature_tabs_container) .MuiTabs-indicator {
    background-color: ${props => props.theme.primary};
  }
  
  #firstSectionStyle {
    overflow: hidden;
    background-color: ${colors.white};
  }

  #analiticSection {
    border-top: 4px dotted #E4E6E8;
    padding-top: 38px;
  }

  .divider-horizontal {
    width: 100% !important;
    margin: -1px !important;
  }
  
  .nearbyPlacesWrapper {
    margin-top: 2rem;
  }
  
  .profileActionButtonsWrapper .divider-horizontal {
    margin-top: 10px!important;
  }

  .divider-vertical {
    margin: -1px !important;
  }

  /* Avatar centrado en su columna, en vertical y en horizontal */
  #imageContainer {
    align-self: center;
    display: flex;
    justify-content: center;
  }

  .divider-profile-stats {
    position: relative !important;
    height: 140px !important;
  }

  /* Alto del título + círculo de 60 px */
  .divider-box-infoheader {
    top: 16px !important;
    position: relative !important;
    height: 88px !important;
  }

  #boxProfileCiteGridContainer {
    padding-right: 35px;
  }

  #documentsInfoContainer {
    margin-top: 35px;
  }
  .documentsInfoBody {
    background-color: #fff;
  }

  .documentsInfoTitle {
    padding: 15px 0;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: ${tokens.color.text.primary};
    margin-bottom: 0;
    margin-right: 3px;
  }

  .tab-item, .candidatureTabs {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid rgba(148,163,178,0.25);
    padding: 10px 0;
    min-height: 40px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${tokens.color.text.primary};
    margin-bottom: 0;
    background-color: rgba(148,163,178,0.18);
    margin-right: 3px;
  }

  .candidature_tabs_container .MuiTabs-indicator {
    display: none!important;
  }

  .candidature_tab_selected {
    background-color: #fff!important;
    font-weight: 600!important;
    opacity: 1!important;
    border-bottom: solid 2px ${props => props.theme.primary};
  }

  .candidature_tab_not_selected {
    background-color: rgba(148,163,178,0.18)!important;
    font-weight: 400!important;
    opacity: 0.5!important;
  }

  @media print {
    .profileStatsInfo-print{
      justify-content:space-between;
    }
    .otherInfoContainer {
      width: 50%;
      //padding: 35px 24px 35px 55px;
      margin-top: 20px;
      p.value{
        font-size: 11px !important;
      }
    }
    

    #boxInfoHeaderGridContainer {
      width: 51%;
    }

    #boxProfileCiteGridContainer {
      padding-right: 0 !important;
      padding-left: 24px !important;
      margin-top: -4px;
    }

    .interview-otes-title-print{
      display: block !important;
      font-size: 18px !important;
    }
  }
    
  //InterviewNotes
  /* Las notas de la entrevista llevan su propio estilo (InterviewNotesPanel) */

  /* Ofertas push y últimas citaciones: sin el Paper de material-table, filas blancas sobre el
     fondo de la página y celdas a 13 px, igual que el histórico de cambios */
  .profile-table {
    background: transparent;
    box-shadow: none;

    tbody tr {
      background: ${tokens.color.background.default};
    }

    .MuiTableCell-body {
      font-size: 13px;
    }
  }
  
  //Tabs
  .tab-item {
    text-transform: none;
    padding: 0 15px;
  }
  .tab-item.Mui-selected{
    background-color: #fff;
  }
  
  .tab-item:not(.Mui-selected) {
    font-weight: 400;
    
  }
  
  .interview-otes-title-print{
    display:none;
  
  }
  
  .offer_table_container table th,
  .last_citations_table_container table th {
    text-align: left!important;
  }
  
  .offer_description {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    text-align: start;
    color: black;
    display: -webkit-box;
    max-width: 200px;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .offer_user_name {
    text-transform: capitalize;
  }
  .header-table {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 15px 0;

    p {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: ${tokens.color.text.primary};
      margin-bottom: 0;
    }
  }

  .custom-edit{
    display: inline-flex;
    cursor: pointer;
  }

`
export default ProfileInfoStyled
